import { adminCall, adminGet } from '../../api/adminCall';

export async function createSpecialAccessInvite({ email }) {
  return adminCall('/api/admin/special-access-invites', { email });
}

export async function listSpecialAccessInvites({ status = 'pending' } = {}) {
  const data = await adminGet(
    `/api/admin/special-access-invites?status=${encodeURIComponent(status || 'pending')}`
  );
  return data.invites || [];
}

export async function resendSpecialAccessInvite({ token }) {
  return adminCall(`/api/admin/special-access-invites/${encodeURIComponent(token)}/resend`);
}

export async function cancelSpecialAccessInvite({ token }) {
  return adminCall(`/api/admin/special-access-invites/${encodeURIComponent(token)}/cancel`);
}
